import React, { memo } from 'react';
import _sortBy from 'lodash/sortBy';
import { useLocation } from 'react-router-dom';

import { Box } from '@mui/material';

import { V2_ROUTE_AREAS } from '@aware/v2-routes/constants';
import { useGetRoutes } from '@aware/hooks';
import DrawerItem from '@common/components/navigation-drawer/drawer-item';
import DrawerHeader from '@common/components/navigation-drawer/drawer-header';
import DrawerHeaderText from '@common/components/navigation-drawer/drawer-header-text';
import DrawerSettingsMenu from '@common/components/navigation-drawer/drawer-settings-menu';
import NavigationDrawer from '@common/components/navigation-drawer/navigation-drawer';

const V2NavigationDrawer = ({ isDrawerOpen }) => {
  const { routesByArea } = useGetRoutes();
  const { pathname } = useLocation();

  return (
    <NavigationDrawer isDrawerOpen={isDrawerOpen}>
      {Object.keys(V2_ROUTE_AREAS).map((area, idx) => {
        if (!routesByArea[area]) return null;

        const { title, settings, navigation } = routesByArea[area];

        // Allows settings icon to have color if a setting within this area is selected
        const areaHasSelectedSetting = settings
          .flatMap(({ paths }) => paths.map(({ path }) => path))
          .some(path => path === pathname);

        const hasSettings = Boolean(settings?.length);

        return (
          <Box key={idx} sx={{ display: 'flex', flexDirection: 'column' }}>
            {title ? (
              <DrawerHeader isDrawerOpen={isDrawerOpen}>
                <DrawerHeaderText isDrawerOpen={isDrawerOpen}>{title}</DrawerHeaderText>

                {hasSettings && (
                  <DrawerSettingsMenu
                    isDrawerOpen={isDrawerOpen}
                    areaHasSelectedSetting={areaHasSelectedSetting}
                    settings={settings}
                    tooltipTitle={`${title} Settings`}
                  />
                )}
              </DrawerHeader>
            ) : null}

            {_sortBy(Object.values(navigation), 'order').map((page, subIdx) => {
              return (
                <DrawerItem
                  key={`page-${subIdx}`}
                  icon={page?.icon}
                  isActive={page?.isActive}
                  linkTo={page?.path}
                  disabled={page?.disabled}
                  isDrawerOpen={isDrawerOpen}
                >
                  {isDrawerOpen
                    ? page?.title
                    : page?.collapsedTitle
                      ? page.collapsedTitle
                      : page?.title}
                </DrawerItem>
              );
            })}
          </Box>
        );
      })}
    </NavigationDrawer>
  );
};

export default memo(V2NavigationDrawer);
